
import React, { Component } from "react";
import WebDesigner from "./WebDesigner";

import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetWBComponentByTypename } from "./Data/WBData";


type DragProps = {

    draggedObject:LayoutNode|null;
    mouseX:number;
    mouseY:number;
    wbManager:WebDesigner;
   
}

type DragState = {

  mouseX:number;
  mouseY:number;
}





export default class DraggedComponent extends Component <DragProps,DragState>{



  constructor(props:DragProps){
    super(props);
    this.state = {mouseX:props.mouseX,mouseY:props.mouseY};
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
  }

  componentDidMount(): void {
    

    this.props.wbManager.draggedRenderComponent = this;
    //document.addEventListener("mousemove",this.handleMouseMove);
   // document.addEventListener("touchmove",this.handleTouchMove);


  }
   
  componentWillUnmount(): void {
    //document.removeEventListener("mousemove",this.handleMouseMove,false);
   // document.removeEventListener("touchmove",this.handleTouchMove,false);
  }

  handleMouseMove(e:MouseEvent){
  
    this.setState({mouseX:e.clientX,mouseY:e.clientY});


  }

  handleTouchMove(e:TouchEvent){

 
   

    for(let i = 0;i<e.touches.length;i++){
      if(e.touches[i].clientX!=this.state.mouseX||e.touches[i].clientY!=this.state.mouseY){

          this.setState({mouseX:e.touches[i].clientX,mouseY:e.touches[i].clientY});
          break;
      }
    }
  }

render(){




  if(!this.props.draggedObject){
    return null;
  }
  else { // if there is no parent, then this should be rendered as a tool box object

    let comp = GetWBComponentByTypename(this.props.draggedObject.typename);
    if(!comp){
      return null;
    }
  
    return(
    <div className="dragging"
    style={{left:this.state.mouseX+"px",top:this.state.mouseY+"px"}}
    
    > <div className="component-slot dragged">{comp.icon}{comp.displayName}</div>

    </div>
);
  }
/*
    return(

        <div className="dragging"
        style={{left:this.state.mouseX+"px",top:this.state.mouseY+"px"}}
        
        >{this.props.draggedObject &&
            RenderRecursive(this.props.draggedObject)
        }

        </div>

    )
    */
  }

}